import api from './authService';

export const eventLogService = {
  /**
   * Start an event for a booking
   */
  startEvent: async (bookingId, data) => {
    const formData = new FormData();
    
    if (data.notes) {
      formData.append('notes', data.notes);
    }
    
    if (data.screenshots && data.screenshots.length > 0) {
      data.screenshots.forEach((file) => {
        formData.append('screenshots[]', file);
      });
    }
    
    const response = await api.post(`/vendor/bookings/${bookingId}/event/start`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  },

  /**
   * End an event for a booking
   */
  endEvent: async (bookingId, data) => {
    const formData = new FormData();
    
    if (data.notes) {
      formData.append('notes', data.notes);
    }
    
    // Only append screenshots if they exist and are not null
    if (data.screenshots && Array.isArray(data.screenshots) && data.screenshots.length > 0) {
      data.screenshots.forEach((file) => {
        formData.append('screenshots[]', file);
      });
    }
    
    const response = await api.post(`/vendor/bookings/${bookingId}/event/end`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  },

  /**
   * Get event logs for a booking
   */
  getEventLogs: async (bookingId) => {
    const response = await api.get(`/bookings/${bookingId}/event/logs`);
    return response.data;
  },
};

